import React from 'react';
import {Card} from "../../../TabsRoute/components/Card";
import {bluePill, greenPill, numberCard, orangePill, pillBase, textStateCard, yellowGreenPill} from "../../styles";
import {GraphBlueSvg} from "../GraphBlue";
import {GraphGreenSvg} from "../GraphGreen";
import {GraphLightGreenSvg} from "../GraphLightGreen";
import {GraphOrangeSvg} from "../GraphOrange";
import {TelephoneBlueSvg} from "../TelephoneBlueSvg";
import {TelephoneGreenSvg} from "../TelephoneGreenSvg";
import {TelephoneYellowGreenSvg} from "../TelephoneLightGreenSvg";
import {TelephoneOrangeSvg} from '../TelephoneOrangeSvg';
import {ncallsCss, phoneCss, rootCss, stateCss, stateLabelCss} from "./styles";


export interface ByStateCallsCardProps {
    variant?: "blue" | "yellow-green" | "green" | "orange";
    calls: number;
    state: string;
}


export const ByStateCallsCard: React.FC<ByStateCallsCardProps> = ({
    variant = "blue",
    calls,
    state,
}) => {


    const getPhoneByVariant = () => {
        switch (variant) {
            case "yellow-green":
                return (
                    <React.Fragment>
                        <TelephoneYellowGreenSvg/>
                        <GraphLightGreenSvg style={{marginLeft: '20px'}}/>
                    </React.Fragment>
                );
            case "green":
                return (
                    <React.Fragment>
                        <TelephoneGreenSvg/>
                        <GraphGreenSvg style={{marginLeft: '20px'}}/>
                    </React.Fragment>
                );
            case "orange":
                return (
                    <React.Fragment>
                        <TelephoneOrangeSvg/>
                        <GraphOrangeSvg style={{marginLeft: '20px'}}/>
                    </React.Fragment>
                );

            case "blue":
            default:
                return (
                    <React.Fragment>
                        <TelephoneBlueSvg/>
                        <GraphBlueSvg style={{marginLeft: '20px'}}/>
                    </React.Fragment>
                );
        }
    }

    return (
        <Card padding={"0 40px"}>
            <div css={rootCss}>
                <div css={phoneCss}>
                    {getPhoneByVariant()}
                </div>
                <div css={[
                    pillBase,
                    variant === "blue" && bluePill,
                    variant === "green" && greenPill,
                    variant === "yellow-green" && yellowGreenPill,
                    variant === "orange" && orangePill,
                    stateLabelCss,
                ]}>
                    By State
                </div>
                <div css={stateCss}>
                    <p css={textStateCard}>{
                            variant == "blue" ? "Virginia" :
                            variant == "green" ? "Pennsylvania" :
                            variant == "yellow-green" ? "Ohio" :
                            variant == "orange" ? "Others" : "Undefined"}</p>
                </div>

                <p css={[ncallsCss, numberCard]}>{
                        calls
                }</p>
            </div>

        </Card>
    );
}